import React, { useRef } from 'react';
import './KartraUpgrade.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  hideUpgradeModal,
  selectIsUpgradeModalVisible,
} from '../../store/slices/ui.slice';
import { AppDispatch } from '../../store/store';
import { openExternalLink } from '../../utils/openExternalLink';
import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/react';
import ApiService from '../../services/Api.service';
import { AppIdentifiers, setToken } from '../../store/slices/token-state.slice';

const KartraUpgrade: React.FC = () => {
  const show = useSelector(selectIsUpgradeModalVisible);
  const dispatch = useDispatch<AppDispatch>();
  const containerRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const container = containerRef.current;
  //
  //   // Always clean up if the modal has gone away, but only if we actually have a container
  //   if (!show) {
  //     container?.innerHTML && (container.innerHTML = '');
  //     return;
  //   }
  //
  //   // If we're showing, we need a container to do anything
  //   if (!container) return;
  //
  //   // 1) Wipe any Kartra globals (try delete, otherwise undefine them)
  //   Object.keys(window)
  //     .filter((k) => /kartra/i.test(k))
  //     .forEach((k) => {
  //       try {
  //         delete (window as any)[k];
  //       } catch {
  //         // if delete fails (non-configurable), just clobber it
  //         try {
  //           (window as any)[k] = undefined;
  //         } catch {
  //           /* swallow */
  //         }
  //       }
  //     });
  //
  //   // 2) Clear out prior markup
  //   container.innerHTML = '';
  //
  //   // 3) Rebuild the placeholder
  //   const placeholder = document.createElement('div');
  //   placeholder.className = 'js_kt_asset_embed js_kartra_trackable_object';
  //   Object.assign(placeholder.dataset, {
  //     ktType: 'pay',
  //     ktEmbed: 'inline',
  //     ktValue: 'Z3SX8iKhwcrK',
  //     ktOwner: 'Pr2bAmrM',
  //   });
  //   container.appendChild(placeholder);
  //
  //   // 4) Inject the script with cache-bust
  //   const script = document.createElement('script');
  //   script.src = `https://app.kartra.com/js/build/front/embed/pay.js?cb=${Date.now()}`;
  //   script.async = true;
  //   script.onload = () => console.log('[Kartra] re-initialized');
  //   script.onerror = () => console.error('[Kartra] script load failed');
  //   container.appendChild(script);
  //
  //   // 5) Cleanup on unmount or hide
  //   return () => {
  //     container.innerHTML = '';
  //   };
  // }, [show]);

  if (!show) return null;

  return (
    <div className="kartra-upgrade-wrapper">
      <div className="kartra-upgrade-box">
        <button
          className="kartra-close-button"
          onClick={() => dispatch(hideUpgradeModal())}
          aria-label="Close"
        >
          &times;
        </button>
        <h2 className="kartra-upgrade-heading">
          This feature requires a Crate Hackers Business Plan.
        </h2>
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonButton
                fill="outline"
                onClick={async () => {
                  const api = ApiService.getApiClient();
                  const response: any =
                    await api.authControllerRefreshSubscriptions();

                  dispatch(
                    setToken(
                      AppIdentifiers.App,
                      response.access_token,
                      null, // TODO: Will bubble ever have a refresh token?
                      Number(response.bubble_expiration),
                    ),
                  );
                }}
              >
                Refresh Subscriptions
              </IonButton>
            </IonCol>
            <IonCol>
              <IonButton
                fill="outline"
                onClick={() =>
                  openExternalLink(
                    'https://www.cratehackers.com/businessplanupgrade',
                  )
                }
              >
                Upgrade Now
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>

        {/*<div ref={containerRef} />*/}
      </div>
    </div>
  );
};

export default KartraUpgrade;
